export default "__VITE_ASSET__8df001db__"